(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["black-friday-product-price-promo"] && !Shopify.designMode) return;
  try {
    /* ==========================================
   DYNAMIC DISCOUNT
   Uses the actual estimated retail metafield
========================================== */

if (!customElements.get('lp-promo-discount')) {

  class LpPromoDiscount extends HTMLElement {

    connectedCallback() {

      if (this.initialized) return;

      this.initialized = true;

      this.badge = this.querySelector('[data-dynamic-discount]');
      this.variantData = this.querySelector('[data-promo-variants]');

      if (!this.badge || !this.variantData) return;

      try {
        this.variants = JSON.parse(this.variantData.textContent);
      } catch (error) {
        this.variants = [];
        return;
      }

      this.handleChange = this.handleChange.bind(this);
      this.handleVariantEvent = this.handleVariantEvent.bind(this);

      document.addEventListener('change', this.handleChange);
      document.addEventListener('variant:change', this.handleVariantEvent);
      document.addEventListener('product:variant-change', this.handleVariantEvent);
      document.addEventListener('variant:changed', this.handleVariantEvent);

      this.updateDiscount(this.dataset.variantId);

    }

    updateDiscount(variantId) {

      if (!variantId || !this.badge) return;

      const variant = this.variants.find(item =>
        String(item.id) === String(variantId)
      );

      if (!variant) return;

      const price = Number(variant.price);
      const estimatedRetailPrice = Number(variant.estimatedRetailPrice);

      if (
        !Number.isFinite(price) ||
        !Number.isFinite(estimatedRetailPrice) ||
        estimatedRetailPrice <= price ||
        estimatedRetailPrice <= 0
      ) {
        this.badge.textContent = '';
        this.badge.hidden = true;
        this.dataset.variantId = variantId;
        return;
      }

      const discount = Math.round(
        ((estimatedRetailPrice - price) / estimatedRetailPrice) * 100
      );

      this.badge.textContent = discount + '% Off';
      this.badge.hidden = discount <= 0;
      this.dataset.variantId = variantId;

    }

    handleChange(event) {

      const target = event.target;

      if (!target || target.name !== 'id') return;

      if (target.type === 'radio' && !target.checked) return;

      this.updateDiscount(target.value);

    }

    handleVariantEvent(event) {

      const detail = event.detail || {};

      const variant =
        detail.variant ||
        detail.selectedVariant ||
        detail;

      if (variant && variant.id) {
        this.updateDiscount(variant.id);
      }

    }

    disconnectedCallback() {

      document.removeEventListener('change', this.handleChange);
      document.removeEventListener('variant:change', this.handleVariantEvent);
      document.removeEventListener('product:variant-change', this.handleVariantEvent);
      document.removeEventListener('variant:changed', this.handleVariantEvent);

      this.initialized = false;

    }

  }

  customElements.define('lp-promo-discount', LpPromoDiscount);

}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["budget-pay"] && !Shopify.designMode) return;
  try {
    function initBudgetPayTimelineSliders(){document.querySelectorAll(".budget-pay-drawer__timeline--slider:not([data-budget-timeline-slider-init])").forEach(timeline=>{timeline.setAttribute("data-budget-timeline-slider-init","");const list=timeline.querySelector("[data-timeline-list]"),prevBtn=timeline.querySelector("[data-budget-timeline-prev]"),nextBtn=timeline.querySelector("[data-budget-timeline-next]");if(!list||!prevBtn||!nextBtn)return;const scrollByPage=direction=>{const delta=list.clientWidth;list.scrollBy({left:direction*delta,behavior:"smooth"})};prevBtn.addEventListener("click",()=>scrollByPage(-1)),nextBtn.addEventListener("click",()=>scrollByPage(1)),list.addEventListener("keydown",event=>{"ArrowLeft"===event.key?(event.preventDefault(),scrollByPage(-1)):"ArrowRight"===event.key&&(event.preventDefault(),scrollByPage(1))})})}function setupBudgetPayTimelineSliders(){initBudgetPayTimelineSliders()}window.initBudgetPayTimelineSliders=initBudgetPayTimelineSliders,"loading"===document.readyState?document.addEventListener("DOMContentLoaded",setupBudgetPayTimelineSliders):setupBudgetPayTimelineSliders(),document.addEventListener("shopify:section:load",initBudgetPayTimelineSliders),document.addEventListener("perf-defer:hydrated",initBudgetPayTimelineSliders);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function() {
    const facetsControlsWrapper = document.querySelector('.facets.facets-controls-wrapper');
    if (!facetsControlsWrapper) return;

    let isDesktop = window.innerWidth >= 750;
    let scrollStopTimeout;
    const scrollStopDelay = 150;

    // Calculate header height and set sticky top position
    function calculateAndSetStickyTop() {
      if (!isDesktop) return;

      // Try to use CSS variable first (set by header.js)
      const headerHeightVar = getComputedStyle(document.body).getPropertyValue('--header-height');
      let headerHeight = 0;

      if (headerHeightVar) {
        // Parse the CSS variable value (e.g., "60px" -> 60)
        headerHeight = parseFloat(headerHeightVar) || 0;
      } else {
        // Fallback: find header element and calculate height
        const header = document.querySelector('header-component') || 
                       document.querySelector('header') || 
                       document.querySelector('.header') || 
                       document.querySelector('[role="banner"]') ||
                       document.querySelector('.site-header') ||
                       document.querySelector('#header-group');
        
        if (header) {
          headerHeight = header.getBoundingClientRect().height;
        }
      }
      
      // Set sticky top position (header height - 1px to prevent overlap)
      facetsControlsWrapper.style.setProperty('--facets-sticky-top', Math.max(0, headerHeight - 1) + 'px');
    }

    // Hide bar while scrolling, show when stopped (only when sticky)
    function handleScroll() {
      if (!isDesktop) return;

      // Check if element is in sticky position (scrolled past original position)
      const rect = facetsControlsWrapper.getBoundingClientRect();
      const stickyTop = parseFloat(getComputedStyle(facetsControlsWrapper).getPropertyValue('--facets-sticky-top')) || 0;
      const isSticky = rect.top <= stickyTop;

      // Toggle a body flag so the sticky header can drop its shadow while the
      // facets controls bar is stuck (restores it automatically when unstuck).
      document.body.classList.toggle('facets-controls-stuck', isSticky);

      // Only apply hide/show behavior when element is sticky
      if (!isSticky) {
        // Not sticky yet - remove hidden class and clear timeout
        facetsControlsWrapper.classList.remove('facets-controls-wrapper--hidden');
        clearTimeout(scrollStopTimeout);
        return;
      }

      // Element is sticky - apply hide/show behavior
      facetsControlsWrapper.classList.add('facets-controls-wrapper--hidden');
      clearTimeout(scrollStopTimeout);
      
      scrollStopTimeout = setTimeout(function() {
        facetsControlsWrapper.classList.remove('facets-controls-wrapper--hidden');
      }, scrollStopDelay);
    }

    // Initialize
    function initStickyPositioning() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', calculateAndSetStickyTop);
      } else {
        // Wait a bit for header to be fully rendered
        setTimeout(calculateAndSetStickyTop, 100);
      }
    }

    initStickyPositioning();

    window.addEventListener('scroll', handleScroll, { passive: true });

    // Recalculate on resize and when header height changes
    let resizeTimeout;
    function handleResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        isDesktop = window.innerWidth >= 750;
        if (isDesktop) {
          calculateAndSetStickyTop();
        } else {
          facetsControlsWrapper.classList.remove('facets-controls-wrapper--hidden');
          document.body.classList.remove('facets-controls-stuck');
          clearTimeout(scrollStopTimeout);
        }
      }, 250);
    }

    window.addEventListener('resize', handleResize);

    // Also recalculate when header height CSS variable changes (for sticky header)
    const headerHeightObserver = new MutationObserver(function() {
      if (isDesktop) {
        calculateAndSetStickyTop();
      }
    });

    // Observe body for CSS variable changes
    if (document.body) {
      headerHeightObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['style']
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["icon"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const iconBlocks = document.querySelector('.share-button');
    const dropHintBlocks = document.querySelector('.drop-a-hint-drawer drawer-button');
    if (dropHintBlocks && iconBlocks) {
      iconBlocks.addEventListener('click', () => {
        dropHintBlocks.click();
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["packaging-box"] && !Shopify.designMode) return;
  try {
    const initPackagingBox = () => {
    const block = document.querySelector('[data-id="packaging-box"]');
    if (!block) return;

    const items = block.querySelectorAll('[data-packaging-item]');
    const priceEl = block.querySelector('[data-packaging-price]');
    const descEl = block.querySelector('[data-packaging-description]');
    const detailsLinkEl = block.querySelector('[data-packaging-details-link]');

    const updateDetailsLink = (item) => {
      if (!detailsLinkEl) return;
      const url = item.getAttribute('data-url');
      if (url) {
        detailsLinkEl.href = url;
        detailsLinkEl.hidden = false;
      } else {
        detailsLinkEl.removeAttribute('href');
        detailsLinkEl.hidden = true;
      }
    };

    /*
      Sync the hidden `shopify-additional-items[1][id|quantity]` inputs that live
      inside the PDP product forms (buy-buttons + sticky-add-to-cart). These power
      the accelerated checkout flow (Shop Pay / PayPal / etc.) so the selected
      packaging box variant is added alongside the main product. When the standard
      (no-variant) box is active, the inputs are disabled so only the main product
      is sent and the JS-driven add-to-cart still pushes the box manually.
      Reference: https://shopify.dev/docs/storefronts/themes/pricing-payments/accelerated-checkout/multiple-product-checkout
    */
    const updateAdditionalCheckoutInputs = (variantId) => {
      const idInputs = document.querySelectorAll('[data-packaging-additional-id]');
      const qtyInputs = document.querySelectorAll('[data-packaging-additional-qty]');
      const enable = Boolean(variantId);

      idInputs.forEach((input) => {
        input.value = enable ? variantId : '';
        input.disabled = !enable;
      });

      qtyInputs.forEach((input) => {
        input.disabled = !enable;
      });
    };

    // Initialize link + accelerated checkout state from the initially active item
    const activeItem = block.querySelector('[data-packaging-item].active');
    if (activeItem) {
      updateDetailsLink(activeItem);
      updateAdditionalCheckoutInputs(activeItem.getAttribute('data-variant-id'));
    }

    items.forEach((item) => {
      item.addEventListener('click', () => {
        // Update active state
        items.forEach((i) => i.classList.remove('active'));
        item.classList.add('active');

        // Update UI
        const price = item.getAttribute('data-price');
        const name = item.getAttribute('data-name');
        if (priceEl) priceEl.textContent = price;
        if (descEl) descEl.textContent = name;

        // Update View Product Details link
        updateDetailsLink(item);

        // Keep accelerated checkout (Shop Pay etc.) hidden inputs in sync
        updateAdditionalCheckoutInputs(item.getAttribute('data-variant-id'));
      });
    });
  };

  // Run on load and after any dynamic updates
  initPackagingBox();
  } catch(e) { console.error(e); }
})();

})();
